import React, {useCallback, useEffect, useState} from 'react';
import {View, Text, ScrollView, Modal, Alert, FlatList, ActivityIndicator} from 'react-native';
import {ImageComp} from '../../components/Image/Image';
import NumberOfGuestsPicker from '../../components/NumberOfGuest/NumberOfGuest';
import PreferredDatePicker from '../../components/preferredDatePicker/PreferredDate';
import OpenSlotRestaurant from './openSlotResaturant';
import HeaderWithBack from '../../components/Header/headerWithBack';
import CustomPressable from '../../components/customPressable/customPressable';
import DatePickerModal from '../../components/datePickerModal/datePickerModal';
import {useCssStyle} from '../../customHook/getCssStyle';
import moment from 'moment';
import {useDispatch, useSelector} from 'react-redux';
import {getCleanUrl} from '../../utils/Helper';
import {
  searchDailyProgrammeData,
  searchVenueAvailability,
} from '../../Redux/Actions/tableReservationAction';
import {useTranslation} from 'react-i18next';
import { resetIsEventModalNeededToOpen } from '../../Redux/Reducers/tableReservationReducer';
import FlashMessageComp from '../../components/flashMessage/flashMessage';
import { getDataLoadingScreen } from '../../js/getDataLoadingScreen';

const TableReserveListDetail = props => {
  const {route, navigation} = props || {};
  const {item} = route.params;
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);
  const [preferredDate, setPreferredDate] = useState(null);
  const [numberOfGuests, setNumberOfGuests] = useState(0);
  const [showTimeSlots, setShowTimeSlots] = useState(false);

  const [venuesAvailability, setVenuesAvailability] = useState([]);
  const [dailyProgrammeData, setDailyProgrammeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [matchedReservation, setMatchedReservation] = useState(null);
  const [showExtraFields, setShowExtraFields] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  // State to store the selected time slot
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [eventModalVisible, setEventModalVisible] = useState(false);

  const {currentWidget} = useSelector(state => state.deviceConfigSlice);
  const tableReservationSlice = useSelector(
    state => state.tableReservationSlice,
  );

  const isEventModalNeededToOpen = tableReservationSlice.isEventModalNeededToOpen;

  const myReservationData =
    tableReservationSlice.myReservations.myReservationData;

  const loadingIndicator = tableReservationSlice.myReservations.loading;

  const venue_id = tableReservationSlice.myReservations.venueId;

  const imgUrl = getCleanUrl(currentWidget?.widgetHeaderImageUrl);

  const getStyles = useCssStyle();

  const handleIncreaseGuest = useCallback(() => {
    setNumberOfGuests(num => num + 1);
  }, []);

  const handleDecreaseGuest = useCallback(() => {
    setNumberOfGuests(num => (num > 0 ? num - 1 : num));
  }, []);

  useEffect(() => {
    if (myReservationData?.data?.results) {
      // Finding the reservation where venue_id matches item.id
      const reservation = myReservationData.data.results.find(
        res => res.venue_id === item.id,
      );
      setMatchedReservation(reservation);
    }
  }, [myReservationData, item.id]);

  // Function to check if there's an event for the current venue's shift_category
  const hasEvent = useCallback(
    (shift_category) => {
      return dailyProgrammeData?.some(
        (event) =>
          event.shift_categories_display?.toLowerCase() === shift_category?.toLowerCase()
      );
    },
    [dailyProgrammeData]
  );


  const handleSelectVenueDetails = async () => {
    setLoading(true);

    //selectedVenueDetails payload
    let selectedVenueDetails = {
      venueId: venue_id,
      guestCount: numberOfGuests,
      date: preferredDate,
      startTime: '',
      endTime: '',
    };

    // dailyProgrammePayload
    let dailyProgrammePayload = {
      venueId: venue_id,
      date: preferredDate,
    };

    try {
      // Calling both APIs concurrently using Promise.all
      const [venueResponse, dailyProgrammeResponse] = await Promise.all([
        searchVenueAvailability(selectedVenueDetails),
        searchDailyProgrammeData(dailyProgrammePayload),
      ]);

      // response from searchVenueAvailability
      if (venueResponse && venueResponse?.data) {
        setVenuesAvailability(venueResponse?.data?.payload?.data);
        setShowTimeSlots(true);
      } else {

        throw new Error('Venue Availability API failed');
      }

      // response from searchDailyProgrammeData
      if (dailyProgrammeResponse && dailyProgrammeResponse?.data) {
        setDailyProgrammeData(dailyProgrammeResponse?.data?.payload?.data);
      } else {
        
        throw new Error('Daily Programme API failed');
      }
    } catch (error) {

      setErrorMessage('Something went wrong. Please try again.');
    
    } finally {
      setLoading(false);
    }
  };

  // Function to handle the reservation process
  const handleReserveTable = () => {
    if (!preferredDate) {
      Alert.alert('Please select a preferred date');
      return;
    }
    if (numberOfGuests === 0) {
      Alert.alert('Please enter a number of guests');
      return;
    }
    handleSelectVenueDetails();
    
  };

  // Function to handle the final submission
  const handleFinalSubmission = () => {

    if (!selectedTimeSlot) {
      Alert.alert('Please select preferred time slot');
      return;
    }
  
    const shiftCategory = venuesAvailability?.availability?.find(
      (venue) => venue.times.some((time) => time === selectedTimeSlot)
    )?.shift_category;
  
    if (shiftCategory && hasEvent(shiftCategory)) {
      if (isEventModalNeededToOpen) {
        setEventModalVisible(true);  // Open the modal
      } 
      // {isEventModalNeededToOpen && setEventModalVisible(true)} 
      // final Make a reservation Logic here -------
      console.log('Proceeding with reservation for time slot:', selectedTimeSlot);
      dispatch(resetIsEventModalNeededToOpen());
      
    } else {
      setShowExtraFields(true); 
      //final Make a reservation Logic here  when not from Event-------
    }
  
  };

  const handleOpenDatePicker = useCallback(() => {
    setIsDatePickerVisible(true);
  }, []);

  // Function to handle date selection
  const handleDateChange = selectedDate => {
    setIsDatePickerVisible(false);

    const formattedDate = moment(selectedDate, 'YYYY/MM/DD').format(
      'YYYY-MM-DD',
    );
    setPreferredDate(formattedDate);
  };

  return (
    <View style={getStyles(['mainContainer'])}>
      <HeaderWithBack navigation={navigation} />
      {loading ? (
        getDataLoadingScreen()
      ) : (
        <>
          <ScrollView showsVerticalScrollIndicator={false}>
            <ImageComp source={imgUrl} style={getStyles(['mainImageStyle'])} />
            <Text style={getStyles(['headerTitle'])}>{item.name}</Text>

            <View style={getStyles(['detailsContainer'])}>
              {item.phone_number && (
                <>
                  <Text style={getStyles(['detailsHeading'])}>
                    {t('tableRes.phone')}
                  </Text>
                  <Text style={getStyles(['detailsText'])}>
                    {item.phone_number}
                  </Text>
                  <View style={getStyles(['line'])} />
                </>
              )}
              {item.address && (
                <>
                  <Text style={getStyles(['detailsHeading'])}>
                    {t('tableRes.location')}
                  </Text>
                  <Text style={getStyles(['detailsText'])}>{item.address}</Text>
                  <View style={getStyles(['line'])} />
                </>
              )}
            </View>

            <CustomPressable
              style={getStyles(['Button'])}
              onPress={() => setIsModalVisible(true)}>
              <Text style={getStyles(['ButtonText'])}>
                {t('tableRes.reserve_table')}
              </Text>
            </CustomPressable>

            {matchedReservation ? (
              <View style={getStyles(['reservationContainer'])}>
                <Text style={getStyles(['reservationHeading'])}>
                  {t('tableRes.my_reservation')}
                </Text>

                {/* Row containing Date, Time, and Canceled Status */}
                <View style={getStyles(['matchedReservation'])}>
                
                  <View>
                    <Text style={getStyles(['matchedReservationDate'])}>
                      {matchedReservation.date}
                    </Text>

                    <View style={getStyles(['matchedReservationInnerCont'])}>
                      <View
                        style={getStyles(['matchedReservationVerticalLine'])}
                      />

                      <Text style={getStyles(['matchedReservationTime'])}>
                        {matchedReservation.arrival_time}
                      </Text>
                    </View>
                  </View>

                  <Text style={getStyles(['matchedResCancelTxt'])}>
                    {matchedReservation.status}
                  </Text>
                </View>
              </View>
            ) : (
              <View style={getStyles(['reservationContainer'])}>
                
                <Text style={getStyles(['reservationHeading'])}>
                  {t('tableRes.my_reservation')}
                </Text>
                {loadingIndicator ? 
                
                (<ActivityIndicator size="large" style={getStyles(['ActivityIndicator'])} />) :
                  
                (
                  <>
                   <View style={getStyles(['line'])} />
                    <Text style={getStyles(['reservationText'])}>
                      {t('tableRes.no_res_found')}
                    </Text>
                   <View style={getStyles(['line'])} />
                  </>
                )}
                
              </View>
            )}
          </ScrollView>

          {/* Modal kept  outside of ScrollView */}
          <Modal
            transparent={true}
            visible={isModalVisible}
            onRequestClose={() => setIsModalVisible(false)}
            animationType="none">
            <View style={getStyles(['modalOverlay'])}>
              <View style={getStyles(['modalContainer'])}>
                <HeaderWithBack navigation={navigation} />

              <ScrollView style={getStyles(['modalContent'])} showsVerticalScrollIndicator = {false}>
                <ImageComp
                  source={imgUrl}
                  style={getStyles(['mainImageStyle'])}
                />

                <View style={getStyles(['modalInnerContent'])}>
                
                  <Text style={getStyles(['modalHeader'])}>{item.name}</Text>
                  <Text style={getStyles(['modalSubheader'])}>
                    {t('tableRes.reserve_table')}
                  </Text>

                  {!showTimeSlots ? (
                    <>
                      <PreferredDatePicker
                        preferredDate={preferredDate}
                        onOpenDatePicker={handleOpenDatePicker}
                        getStyles={getStyles}
                      />
                      <NumberOfGuestsPicker
                        numberOfGuests={numberOfGuests}
                        onIncrease={handleIncreaseGuest}
                        onDecrease={handleDecreaseGuest}
                        onChangeText={text => {
                          const num = parseInt(text, 10);
                          if (!isNaN(num)) {
                            setNumberOfGuests(num);
                          }
                        }}
                        getStyles={getStyles}
                      />
                    </>
                  ) : (
                    <OpenSlotRestaurant
                      getStyles={getStyles}
                      venuesAvailability={venuesAvailability}
                      dailyProgrammeData = {dailyProgrammeData}
                      selectedTimeSlot={selectedTimeSlot}
                      setSelectedTimeSlot={setSelectedTimeSlot}
                      hasEvent = {hasEvent}
                      showExtraFields = {showExtraFields}
                      setShowExtraFields = {setShowExtraFields}
                      eventModalVisible={eventModalVisible}
                      setEventModalVisible = {setEventModalVisible}
                    />
                  )}

                  <CustomPressable
                    style={getStyles(['modalButton'])}
                    onPress={() => {
                      if (showTimeSlots) {
                        // handle final submission
                        handleFinalSubmission();
                      } else {
                        handleReserveTable();
                      }
                    }}>
                    <Text style={getStyles(['ButtonText'])}>
                    {showExtraFields ? t('tableRes.make_reservation') : t('tableRes.continue')}
                    </Text>
                  </CustomPressable>

                  <CustomPressable
                    style={getStyles(['modalButton'])}
                    onPress={() => {
                      if (showTimeSlots) {
                        setShowTimeSlots(false);
                      } else {
                        setIsModalVisible(false);
                      }
                    }}>
                    <Text style={getStyles(['ButtonText'])}>
                      {t('tableRes.back')}
                    </Text>
                  </CustomPressable>

                 </View>
                </ScrollView>
              </View>
            </View>

            <DatePickerModal
              isVisible={isDatePickerVisible}
              onClose={() => setIsDatePickerVisible(false)}
              onDateChange={handleDateChange}
              selectedDate={preferredDate}
              getStyles={getStyles}
              showExtraFields={showExtraFields}
            />
    
          <FlashMessageComp message={errorMessage} type="danger"/>

          </Modal>
        </>
      )}
    </View>
  );
};

export default TableReserveListDetail;
